// Keep context identity outside the provider's React Fast Refresh boundary.
import { createContext } from 'react';
import type { HapticFeedbackApi } from '../services/haptics';
import type { Platform, PlatformCapabilities } from '../types/platform';
import type { TelegramWebApp, AppType } from '../types';

export interface PlatformContextValue {
    platform: Platform;
    capabilities: PlatformCapabilities;
    isInitialized: boolean;
    isTelegramMiniApp: boolean;
    isNativeApp: boolean;
    isWeb: boolean;
    isIOS: boolean;
    isAndroid: boolean;
    telegram: TelegramWebApp | null;
    telegramUser?: TelegramWebApp['initDataUnsafe']['user'];
    startParam?: string;
    appType: AppType;
    hapticFeedback: HapticFeedbackApi;
    checkPushPermission: () => Promise<{ granted: boolean; denied: boolean; prompt: boolean }>;
    requestPushPermission: () => Promise<boolean>;
}

export const PlatformContext = createContext<PlatformContextValue | null>(null);

